import { render, staticRenderFns } from "./ImportHeader.vue?vue&type=template&id=0e2242a1&"
import script from "./ImportHeader.vue?vue&type=script&lang=js&"
export * from "./ImportHeader.vue?vue&type=script&lang=js&"
import style0 from "./ImportHeader.vue?vue&type=style&index=0&id=0e2242a1&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports